
import React from 'react';
import BaseDialog from './BaseDialog';

const FilePreviewDialog = ({ isOpen, onClose, fileUrl, fileName, fileType }) => {
    if (!isOpen) return null;

    const isImage = fileType?.startsWith('image/') || fileName?.match(/\.(jpg|jpeg|png|gif|webp)$/i);
    const isPdf = fileType === 'application/pdf' || fileName?.match(/\.pdf$/i);

    return (
        <BaseDialog
            isOpen={isOpen}
            onClose={onClose}
            title={`Preview: ${fileName || 'Document'}`}
            size="xl"
        >
            <div className="flex justify-center items-center h-[calc(100vh-200px)] min-h-[400px] bg-gray-100 rounded-lg overflow-hidden p-1">
                {isImage ? (
                    <img src={fileUrl} alt={fileName} className="max-w-full max-h-full object-contain" />
                ) : isPdf ? (
                    <iframe src={fileUrl} title={fileName} className="w-full h-full border-0" />
                ) : (
                    <div className="text-center p-8">
                        <div className="mb-4 text-gray-400">
                            <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                            </svg>
                        </div>
                        <p className="mb-4 text-gray-600 text-lg">Preview not available for this file type.</p>
                        <p className="text-sm text-gray-500 mb-6">{fileName}</p>
                        <a
                            href={fileUrl}
                            download={fileName}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-6 py-2.5 bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 transition shadow-sm"
                        >
                            Download File
                        </a>
                    </div>
                )}
            </div>

        </BaseDialog>
    );
};

export default FilePreviewDialog;
